/**
 * Базовые домены платформы. Слаг тенанта — всё между схемой и `.{base}`.
 * Слаги могут содержать точки: bi.group.buildex.com → 'bi.group' (§6).
 * ⚠️ wildcard-сертификат *.buildex.com не покрывает многоуровневые поддомены —
 * учтено на стороне бэка/девопса, на фронт не влияет.
 */
const BASE_DOMAINS = ['buildex.com', 'buildex.app', 'localhost'] as const;

/**
 * Единственное место, где парсится hostname (§6).
 * null — основной сайт (buildex.com) либо неизвестный хост.
 */
export function resolveTenantSlug(hostname: string): string | null {
  const host = hostname.toLowerCase();

  for (const base of BASE_DOMAINS) {
    if (host === base || host === `www.${base}`) {
      return null;
    }
    if (host.endsWith(`.${base}`)) {
      const slug = host.slice(0, -(base.length + 1));
      return slug === 'www' ? null : slug;
    }
  }

  return null;
}
